(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tbv-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbv-delivery-estimate')) {
    customElements.define(
      'tbv-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const minimumDays = Number.parseInt(this.dataset.minDays, 10) || 8;
          const maximumDays = Number.parseInt(this.dataset.maxDays, 10) || 12;
          const today = new Date();
          const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + minimumDays);
          const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + maximumDays);
          const range = this.querySelector('[data-delivery-range]');

          if (range) {
            range.textContent = this.formatRange(startDate, endDate);
          }
        }

        formatRange(startDate, endDate) {
          const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
          const startDay = `${startDate.getDate()}${this.ordinalSuffix(startDate.getDate())}`;
          const endDay = `${endDate.getDate()}${this.ordinalSuffix(endDate.getDate())}`;

          if (startDate.getFullYear() !== endDate.getFullYear()) {
            return `${months[startDate.getMonth()]} ${startDay}, ${startDate.getFullYear()} – ${months[endDate.getMonth()]} ${endDay}, ${endDate.getFullYear()}`;
          }

          if (startDate.getMonth() !== endDate.getMonth()) {
            return `${months[startDate.getMonth()]} ${startDay} – ${months[endDate.getMonth()]} ${endDay}`;
          }

          return `${months[startDate.getMonth()]} ${startDay} – ${endDay}`;
        }

        ordinalSuffix(day) {
          const lastTwoDigits = day % 100;

          if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th';
          if (day % 10 === 1) return 'st';
          if (day % 10 === 2) return 'nd';
          if (day % 10 === 3) return 'rd';
          return 'th';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
